import React from "react";
import styles from './home.module.css'
import Panels from "../../components/panels/panels";
import planing from '../../images/planing.svg'

export default function Home() {
    return (
        <div className={styles.content}>
            <div className={styles.header}>
                <div className={styles.gradient}></div>
                <div className={styles.name}>INDUSTRIAL CITIES</div>
            </div>
            <Panels/>
            <div className={styles.headerPlaning}>
                <img className={styles.iconPlaning} src={planing}/>
                <div className={styles.namePlaning}>FUTURE INDUSTRIAL CITIES</div>
            </div>
            <Panels/>
        </div>
    );
}